import React from "react";
import { Box, Card } from "@mui/material";

const SpecialCard = ({ children, backgroundColor, containerProps, ...props }) => {
  return (
    <Box
      {...containerProps}
      sx={{
        padding: "2px",
        borderRadius: "20px",
        background:
          "linear-gradient(180deg, #0596A1 0%, #3971F6 19.71%, #9A45F4 42.31%, #FC7D06 61.54%, #F7E144 80.77%, #FF4626 100%)",
        transition: "transform .3s ease",
        "&:hover": {
          transform: "scale(1.05)",
        },
        ...containerProps?.sx
      }}
    >
      <Card
        {...props}
        sx={{
          padding: "20px",
          borderRadius: "18px",
          backgroundColor: (theme) =>
            backgroundColor ? backgroundColor : theme.palette.background.paper,
          ...props.sx,
        }}
      >
        {children}
      </Card>
    </Box>
  );
};

export default SpecialCard;
